import { rpcContract } from "../rpc";
import * as v from "valibot";

export const createFeedbackRpcContract = rpcContract({
  name: "createFeedback",
  paramsSchema: v.object({
    pageUrl: v.string(),
    comment: v.optional(v.string()),
    isPositive: v.optional(v.boolean()),
    username: v.optional(v.string()),
    userId: v.optional(
      v.pipe(
        v.string("userId must be a string"),
        v.uuid("Invalid userId: must be a valid UUID (e.g., 123e4567-e89b-12d3-a456-426614174000)"),
      ),
    ),
  }),
  resultSchema: v.object({
    feedbackId: v.string(),
  }),
});

export type CreateFeedbackParams = v.InferOutput<(typeof createFeedbackRpcContract)["paramsSchema"]>;
export type CreateFeedbackResult = v.InferOutput<(typeof createFeedbackRpcContract)["resultSchema"]>;
